export default "__VITE_ASSET__b85M1KeH__"